<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
export default {
  name: 'App',
  created() {
    // if(!this.userToken) {
    //   this.$router.push('login');
    // }
    if(!this.id) {
      this.$router.push('login');
    }
    console.log("this.token:",this.userToken);
    console.log("this.id:",this.id)
  },
  computed:{
    ...mapState({
      userToken: state => state.userModule.token,
      id:state=> state.userModule.id,
    })
  },
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  font-family:黑体;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px !important;
  cursor: pointer !important;
  position: relative !important;
  overflow: hidden !important;
}
.avatar-uploader .el-upload:hover {
  border-color: #FE5404 !important;
}
.el-submenu__title, .el-menu-item {
  height: 51px !important;
  line-height: 51px !important;
  /*margin-left: 100px;*/
}
.el-submenu .el-menu-item {
  height: 41px !important;
  line-height: 41px !important;
}
.el-submenu__title {
  padding-left: 50px !important;
}
.el-menu-item {
  padding-left: 85px !important;
}
.el-aside {
  width: 210px !important;
  background: rgb(39, 40, 47) !important;
}
.el-submenu .el-menu-item {
  background-color: #1b1b22 !important;
}
form {
  background: white !important;
  padding: 22px 28px !important;
  margin-left: 0 !important;
}
.el-pagination {
  padding-top: 20px !important;
  background: white !important;
  padding-bottom: 20px !important;
  padding-left: 28px !important;
}
.tableBox {
  padding: 0 28px !important;
  background: white !important;
}
.tableForm {
  background: white !important;padding: 22px 28px !important
}
.addButton {
  border-color: #FE5404 !important;color: #FE5404 !important
}
.addButton:hover {
  border-color: rgba(254, 84, 4, 0.75) !important;color: rgba(254, 84, 4, 0.75) !important;background-color: rgba(254, 84, 4, 0.02) !important;
}
.el-button--text {
  color: #FE5404 !important;
}
.el-button--text:hover {
  color: rgba(254, 84, 4, 0.7) !important;
}
.el-pager li.active {
  color: #FE5404 !important;
}
.el-button--primary {
  color: #fff !important;
  background-color: #FE5404 !important;
  border-color: #FE5404 !important;
}
.el-button--primary:hover {
  background-color: rgba(254, 84, 4, 0.7) !important;
  border-color: rgba(254, 84, 4, 0.7) !important;
}
.el-radio.is-bordered.is-checked {
  border-color: #FE5404 !important;
}
.el-radio.is-bordered.is-checked span {
  color: #FE5404 !important;
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: #FE5404 !important;
  background: #FE5404 !important;
}
.el-radio__input.is-checked+.el-radio__label {
  color: #FE5404 !important;
}
.el-tag {
  color: #FE5404 !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #FE5404 !important;
  border-color: #FE5404 !important;
}
.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #FE5404 !important;
}
.button-new-tag:hover {
  color: #FE5404 !important;
}
.el-tag .el-icon-close {
  color: #FE5404 !important;
}
.el-tag .el-icon-close:hover {
  background-color: #FE5404 !important;
}
.el-button {
  /*background: green;*/
}
.el-menu-item.is-active {
    background-color: red !important;
    background-image:linear-gradient(-180deg, #f6b012 0%, #fe5404 100%) !important;
  }
.el-table__expand-icon>.el-icon {
  color: #FE5404 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue